export const firebaseConfig = ((nodeEnv, projectId) => {
  if (nodeEnv === 'production' && projectId === 'nitaku-prod') {
    return {
      apiKey: "AIzaSyDnr0cofnyVLMC06m8zxgZ5_sm6cciDgTQ",
      authDomain: "nitaku-prod.firebaseapp.com",
      databaseURL: "https://nitaku-prod.firebaseio.com",
      projectId: "nitaku-prod",
      storageBucket: "nitaku-prod.appspot.com",
      messagingSenderId: "736311661616",
      appId: "1:736311661616:web:a50752bacb8010895f89f5",
      measurementId: "G-0QF39HFQN0"
    }
  } else {
    return {
      apiKey: "AIzaSyAI4-8N84Ogk8D7ed3I40QU0lYLnO66w3I",
      authDomain: "nitaku-dev-2d298.firebaseapp.com",
      databaseURL: "https://nitaku-dev-2d298.firebaseio.com",
      projectId: "nitaku-dev-2d298",
      storageBucket: "nitaku-dev-2d298.appspot.com",
      messagingSenderId: "13351000149",
      appId: "1:13351000149:web:1d6ea2ab5250735fa95cdc",
      measurementId: "G-00D07TCPTE"
    }
  }
})(process.env.NODE_ENV, process.env.REACT_APP_PROJECT_ID);
